import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _statusTitles, _statusIconsSmall, _statusIconsLarge, _iconComponents, _textSizeConstants;

import React from 'react';
import { IconClockFill, IconCheckCircleFill, IconAlertTriangleFill, IconAlertCircleFill, IconInformationFill, IconPadlockFill, IconSize } from "../icons";
import { LoadingStatusSpinner } from "./LoadingStatusSpinner";
import { Status, StatusIndicatorSize } from "./interfaces";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var statusTitles = (_statusTitles = {}, _defineProperty(_statusTitles, Status.Positive, 'Success'), _defineProperty(_statusTitles, Status.Warning, 'Warning'), _defineProperty(_statusTitles, Status.Negative, 'Error'), _defineProperty(_statusTitles, Status.Information, 'Information'), _defineProperty(_statusTitles, Status.Waiting, 'Pending'), _defineProperty(_statusTitles, Status.Loading, 'Loading'), _defineProperty(_statusTitles, Status.Unavailable, 'Not available'), _statusTitles);
var statusIconsSmall = (_statusIconsSmall = {}, _defineProperty(_statusIconsSmall, Status.Positive, function (props) {
  return ___EmotionJSX(IconCheckCircleFill, _extends({
    size: IconSize.ExtraSmall,
    color: "green70",
    title: statusTitles[Status.Positive]
  }, props));
}), _defineProperty(_statusIconsSmall, Status.Warning, function (props) {
  return ___EmotionJSX(IconAlertTriangleFill, _extends({
    size: IconSize.ExtraSmall,
    color: "yellow80",
    title: statusTitles[Status.Warning]
  }, props));
}), _defineProperty(_statusIconsSmall, Status.Negative, function (props) {
  return ___EmotionJSX(IconAlertCircleFill, _extends({
    size: IconSize.ExtraSmall,
    color: "red70",
    title: statusTitles[Status.Negative]
  }, props));
}), _defineProperty(_statusIconsSmall, Status.Information, function (props) {
  return ___EmotionJSX(IconInformationFill, _extends({
    size: IconSize.ExtraSmall,
    color: "neutral70",
    title: statusTitles[Status.Information]
  }, props));
}), _defineProperty(_statusIconsSmall, Status.Waiting, function (props) {
  return ___EmotionJSX(IconClockFill, _extends({
    size: IconSize.ExtraSmall,
    color: "neutral70",
    title: statusTitles[Status.Waiting]
  }, props));
}), _defineProperty(_statusIconsSmall, Status.Unavailable, function (props) {
  return ___EmotionJSX(IconPadlockFill, _extends({
    size: IconSize.ExtraSmall,
    color: "neutral70",
    title: statusTitles[Status.Unavailable]
  }, props));
}), _defineProperty(_statusIconsSmall, Status.Loading, function (props) {
  return ___EmotionJSX(LoadingStatusSpinner, _extends({
    size: 16,
    title: statusTitles[Status.Loading]
  }, props));
}), _defineProperty(_statusIconsSmall, Status.Neutral, null), _statusIconsSmall);
var statusIconsLarge = (_statusIconsLarge = {}, _defineProperty(_statusIconsLarge, Status.Positive, function (props) {
  return ___EmotionJSX(IconCheckCircleFill, _extends({
    size: IconSize.Small,
    color: "green70",
    title: statusTitles[Status.Positive]
  }, props));
}), _defineProperty(_statusIconsLarge, Status.Warning, function (props) {
  return ___EmotionJSX(IconAlertTriangleFill, _extends({
    size: IconSize.Small,
    color: "yellow80",
    title: statusTitles[Status.Warning]
  }, props));
}), _defineProperty(_statusIconsLarge, Status.Negative, function (props) {
  return ___EmotionJSX(IconAlertCircleFill, _extends({
    size: IconSize.Small,
    color: "red70",
    title: statusTitles[Status.Negative]
  }, props));
}), _defineProperty(_statusIconsLarge, Status.Information, function (props) {
  return ___EmotionJSX(IconInformationFill, _extends({
    size: IconSize.Small,
    color: "neutral70",
    title: statusTitles[Status.Information]
  }, props));
}), _defineProperty(_statusIconsLarge, Status.Waiting, function (props) {
  return ___EmotionJSX(IconClockFill, _extends({
    size: IconSize.Small,
    color: "neutral70",
    title: statusTitles[Status.Waiting]
  }, props));
}), _defineProperty(_statusIconsLarge, Status.Unavailable, function (props) {
  return ___EmotionJSX(IconPadlockFill, _extends({
    size: IconSize.Small,
    color: "neutral70",
    title: statusTitles[Status.Unavailable]
  }, props));
}), _defineProperty(_statusIconsLarge, Status.Loading, function (props) {
  return ___EmotionJSX(LoadingStatusSpinner, _extends({
    size: 20,
    title: statusTitles[Status.Loading]
  }, props));
}), _defineProperty(_statusIconsLarge, Status.Neutral, null), _statusIconsLarge);
export var iconComponents = (_iconComponents = {}, _defineProperty(_iconComponents, StatusIndicatorSize.Small, statusIconsSmall), _defineProperty(_iconComponents, StatusIndicatorSize.Large, statusIconsLarge), _iconComponents);
export var textSizeConstants = (_textSizeConstants = {}, _defineProperty(_textSizeConstants, StatusIndicatorSize.Small, {
  fontSize: 'T100'
}), _defineProperty(_textSizeConstants, StatusIndicatorSize.Large, {
  fontSize: 'T300'
}), _textSizeConstants);